import axios, { endpoints } from 'src/utils/axios';

import { setAccessToken } from './utils';

/** **************************************
 * Login
 *************************************** */
export const loginWithPassword = async ({ email, password }) => {
  const params = { email, password };

  const res = await axios.post(endpoints.auth.login, params);
  const { token } = res.data;

  if (!token) {
    throw new Error('Access token not found in response');
  }

  setAccessToken(token);
};

/** **************************************
 * Logout
 *************************************** */
export const logout = async () => {
  setAccessToken(null);
};
